module.exports = __webpack_public_path__ + "static/media/arrow.56b7235d.svg";